<ion-grid>
  <ion-row>
    <ion-col id="col-container" size-sm="12">
      <div #canvasElement [style.height.px]="currentHeight" id="canvas-container">
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
